
interface ProjectCardProps {
  project: {
    id: number;
    name: string;
    technologies: string[];
    description: string;
    githubLink?: string;
    liveLink?: string;
  };
}

function ProjectCard({ project }: ProjectCardProps) {
  return (
    <div
      key={project.id}
      className="bg-[#1a1a1d]  rounded-lg p-6 hover:bg-[#1f1f23] sticky top-12 sm:relative"
    >
      <h3 className="text-xl font-bold text-gray-100 mb-3">{project.name}</h3>
      <div className="flex flex-wrap gap-2 mb-3 mt-5">
        {project.technologies.map((tech, techIndex) => (
          <span
            key={techIndex}
            className="bg-[#016e86] text-white text-xs px-3 py-1 rounded-full"
          >
            {tech}
          </span>
        ))}
      </div>
      <p className="text-gray-400 mb-4 text-left">{project.description}</p>
      <div className="space-x-3 hidden">
        {project.githubLink && (
          <a
            href={project.githubLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300 underline"
          >
            GitHub
          </a>
        )}
        {project.liveLink && (
          <a
            href={project.liveLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300 underline"
          >
            Live Demo
          </a>
        )}
      </div>
      <div className="w-full flex items-center justify-center md:justify-end text-white cursor-pointer">
        <a
          href={`projects/${project.id}`}
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300 text-sm underline"
        >
          Read More
        </a>
      </div>
    </div>
  );
}

export default ProjectCard;
